//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
    /*
     * This filter applies some formatting changes for the stat bubble directive.
     *
     * @param input      The object originally supplied to the stat bubble. It must have a value and a dataType.
     * @param formatter  If a custom formatting function is supplied, run the data through that as well.
     * @param decorate   If true, we'll apply the 'formatter' function to the default formatted data output (rather
     *                   than the supplied input).
     *
     * @return The final, formatted output for a stat bubble.
     */

  angular.module('curalate').filter('statBubbleFormatter', [
    '$filter',
    function(
            $filter,
        ) {
      return function(input, formatter, decorate) {
        let abs;
        let value = input.value;
        const dataType = input.dataType.trim().toLowerCase();
        const defaultFormatOutput = {};

                // First get the default formatted object
        switch (dataType) {
          case ('percent'):
            defaultFormatOutput.value = `${$filter('number')(value, 1)}%`;
            defaultFormatOutput.label = '';
            break;
          case ('currency'):
            defaultFormatOutput.value = $filter('currency')(value);
            defaultFormatOutput.label = '';
            break;
          default: // This is the default formatting for a dataType "number"
            abs = Math.abs(value);
            if (abs >= 10 ** 12) {
              value = `${(value / 10 ** 12).toFixed(1)}T`;
            } else if (abs < 10 ** 12 && abs >= 10 ** 9) {
              value = `${(value / 10 ** 9).toFixed(1)}B`;
            } else if (abs < 10 ** 9 && abs >= 10 ** 6) {
              value = `${(value / 10 ** 6).toFixed(1)}M`;
            } else if (abs < 10 ** 6 && abs >= 10 ** 3) {
              value = `${(value / 10 ** 3).toFixed(1)}K`;
            }
            defaultFormatOutput.value = value;
        }

                // If decorate is true, then we want to apply the custom formatter (if one is supplied) to
                // the default formatted output. Otherwise we'll apply it to the supplied input.
        const inputForCustomFormatter = decorate ? defaultFormatOutput : input;
        const customFormatOutput = formatter ? formatter(inputForCustomFormatter) : null;

        return customFormatOutput || defaultFormatOutput;
      };
    },
  ]);
})();
